export namespace Users {
  export const keys = {
    user: () => ["user"] as const,
  };
}

export namespace Facilities {
  export const keys = {
    facility: () => ["facility"] as const,
  };
}
